import styled from "styled-components";

const SelectWrapper = styled.div`
  align-self: flex-end;

  > p {
    margin-bottom: 5px;
    /* font-size: 20px; */
  }
  /* @media screen and (max-width: 500px) {
    > p {
      font-size: 16px;
    }
  } */

  select {
    border: 1px solid #ccc;
    width: 100%;
    height: var(--input-height);
    border-radius: 5px;
    padding-inline: 10px;
    font-size: 16px;
    color: "#000";
    cursor: pointer;
  }

  select option:first-child {
    color: #000;
  }

  @media screen and (max-width: 500px) {
    select {
      font-size: 16px;
    }
  }
`;

export default SelectWrapper;
